<template>
  <common-selector-constraint
    :allowed-values.sync="allowedData"
    :forbidden-values.sync="forbiddenData"
    :data-source="dataSource"
  />
</template>

<script>
import CommonSelectorConstraint from "@/components/excel/designer/common/common-selector-constraint";
const dataSource = Array.from(Array(31))
  .map((_, idx) => idx + 1)
  .map((it) => ({ value: it, text: `${it}` }));
export default {
  name: "day-selector-constraint",
  components: { CommonSelectorConstraint },
  props: {
    forbiddenValues: {
      type: Array,
    },
    allowedValues: {
      type: Array,
    },
  },
  computed: {
    allowedData: {
      get() {
        return this.$props.allowedValues;
      },
      set(value) {
        this.changeAllowed(value);
      },
    },
    forbiddenData: {
      get() {
        return this.$props.forbiddenValues;
      },
      set(value) {
        this.changeForbidden(value);
      },
    },
  },
  data() {
    return {
      dataSource,
    };
  },
  methods: {
    changeAllowed(value) {
      this.$emit("update:allowed-values", value);
      this.$emit("change-allowed-values", value);
    },
    changeForbidden(value) {
      this.$emit("update:forbidden-values", value);
      this.$emit("change-forbidden-values", value);
    },
  },
};
</script>
